module.exports = __webpack_public_path__ + "static/media/fondo_red_tecnologica.da41fd27.png";